import './NuiAccordion.less';
import React from 'react';
import clsx from 'clsx';

export interface NuiAccordionTitleProps {
    title: string;
    isOpen: boolean;
    onChangeOpen: () => void;
}

export default function NuiAccordionHeader({ title, isOpen = false, onChangeOpen }: NuiAccordionTitleProps) {
    return (
        <header className="nui-accordion-title-component" onClick={onChangeOpen}>
            <div className={clsx('nui-accordion-title c-black-100', { 'is-accordion-open': isOpen })}>{title}</div>
            <div className={clsx('toggle-btn pointer', { active: isOpen })}>
                <span className="accordion-open-arrow"></span>
            </div>
        </header>
    );
}
